// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   CancelScheduleModal.css
   =========================================*/

/* ----- Overlay --------------------------------------------------- */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  background: rgba(0, 0, 0, 0.55);
}

/* ----- Container ------------------------------------------------- */
.reschedule-modal {
  /* raiz reaproveitada */
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: modal-pop 0.25s ease-out;
}

@keyframes modal-pop {
  from {
    transform: translateY(16px) scale(0.96);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* ----- Header ---------------------------------------------------- */
.modal-header {
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  flex: 1 1;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
}

.modal-header label {
  /* "Selecionar todos" */
  color: #374151;
  font-size: 0.875rem;
  -webkit-user-select: none;
          user-select: none;
}

.modal-header input[type="checkbox"] {
  accent-color: #2563eb;
}

/* X de fechar */
.close-button {
  background: transparent;
  border: 0;
  padding: 0.25rem;
  line-height: 0;
  color: #6b7280;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
}
.close-button:hover,
.close-button:focus-visible {
  background: #f3f4f6;
  color: #111827;
  outline: none;
}

/* ----- Corpo ----------------------------------------------------- */
.modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1.5rem;
}

/* Info paciente / médico */
.modal-body p {
  margin: 0 0 0.75rem;
  color: #374151;
  font-size: 0.875rem;
}

/* Lista de procedimentos */
.procedure-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.procedure-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: #f3f6fa;
  border: 1px solid #d9e2ef;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  transition: border-color 0.15s, background 0.15s;
}

.procedure-item input[type="checkbox"] {
  margin-top: 3px;
  accent-color: #d97706; /* laranja leve só pra diferenciar */
}

.procedure-item h4 {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.procedure-item small {
  font-size: 0.75rem;
  color: #6b7280;
}

/* Motivo */
#cancel-reason {
  width: 100%;
  min-height: 90px;
  font-size: 0.875rem;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  transition: border-color 0.15s, box-shadow 0.15s;
}
#cancel-reason:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
  outline: none;
}

/* ----- Footer ---------------------------------------------------- */
.modal-footer {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #e5e7eb;
}

.cancel-button,
.danger-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  border-radius: 6px;
  border: 0;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
}

/* Voltar */
.cancel-button {
  background: #f3f4f6;
  color: #374151;
  padding: 0.5rem 1.125rem;
}
.cancel-button:hover,
.cancel-button:focus-visible {
  background: #e5e7eb;
}

/* Confirmar cancelamento */
.danger-button {
  background: #dc2626; /* red-600 */
  color: #ffffff;
  padding: 0.5rem 1.25rem;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.4);
}
.danger-button:hover,
.danger-button:focus-visible {
  background: #b91c1c;
}
.danger-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

/* ----- Responsividade ------------------------------------------- */
@media (max-width: 640px) {
  .procedure-item {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/cancelModal.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C,sEAAsE;AACtE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,qBAAqB,EAAE,oCAAoC;AAC7D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;AACA;;EAEE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB,EAAE,YAAY;EACjC,cAAc;EACd,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* =========================================\n   CancelScheduleModal.css\n   =========================================*/\n\n/* ----- Overlay --------------------------------------------------- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(2px);\n  background: rgba(0, 0, 0, 0.55);\n}\n\n/* ----- Container ------------------------------------------------- */\n.reschedule-modal {\n  /* raiz reaproveitada */\n  width: 100%;\n  max-width: 640px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: modal-pop 0.25s ease-out;\n}\n\n@keyframes modal-pop {\n  from {\n    transform: translateY(16px) scale(0.96);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* ----- Header ---------------------------------------------------- */\n.modal-header {\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modal-header label {\n  /* \"Selecionar todos\" */\n  color: #374151;\n  font-size: 0.875rem;\n  user-select: none;\n}\n\n.modal-header input[type=\"checkbox\"] {\n  accent-color: #2563eb;\n}\n\n/* X de fechar */\n.close-button {\n  background: transparent;\n  border: 0;\n  padding: 0.25rem;\n  line-height: 0;\n  color: #6b7280;\n  border-radius: 6px;\n  transition: background 0.15s, color 0.15s;\n}\n.close-button:hover,\n.close-button:focus-visible {\n  background: #f3f4f6;\n  color: #111827;\n  outline: none;\n}\n\n/* ----- Corpo ----------------------------------------------------- */\n.modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 1.5rem;\n}\n\n/* Info paciente / médico */\n.modal-body p {\n  margin: 0 0 0.75rem;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n/* Lista de procedimentos */\n.procedure-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.procedure-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  background: #f3f6fa;\n  border: 1px solid #d9e2ef;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.procedure-item input[type=\"checkbox\"] {\n  margin-top: 3px;\n  accent-color: #d97706; /* laranja leve só pra diferenciar */\n}\n\n.procedure-item h4 {\n  margin: 0 0 2px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.procedure-item small {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* Motivo */\n#cancel-reason {\n  width: 100%;\n  min-height: 90px;\n  font-size: 0.875rem;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n#cancel-reason:focus-visible {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n  outline: none;\n}\n\n/* ----- Footer ---------------------------------------------------- */\n.modal-footer {\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancel-button,\n.danger-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 0;\n  cursor: pointer;\n  transition: background 0.15s, box-shadow 0.15s;\n}\n\n/* Voltar */\n.cancel-button {\n  background: #f3f4f6;\n  color: #374151;\n  padding: 0.5rem 1.125rem;\n}\n.cancel-button:hover,\n.cancel-button:focus-visible {\n  background: #e5e7eb;\n}\n\n/* Confirmar cancelamento */\n.danger-button {\n  background: #dc2626; /* red-600 */\n  color: #ffffff;\n  padding: 0.5rem 1.25rem;\n  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.4);\n}\n.danger-button:hover,\n.danger-button:focus-visible {\n  background: #b91c1c;\n}\n.danger-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* ----- Responsividade ------------------------------------------- */\n@media (max-width: 640px) {\n  .procedure-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
